// Inicialización de Sentry para el frontend. Condicional por VITE_SENTRY_DSN (regla 10).

import * as Sentry from '@sentry/react';

export function initObservability(): void {
  const dsn = import.meta.env['VITE_SENTRY_DSN'];
  if (!dsn) {
    if (import.meta.env.DEV) console.log('[sentry] disabled (VITE_SENTRY_DSN not set)');
    return;
  }
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
  });
  console.log(`[sentry] initialized (env=${import.meta.env.MODE})`);
}

export { Sentry };
